export enum TravelAnalysisMessages {
  pageTitle = "travelAnalysis.pageTitle",
  filterButton = "travelAnalysis.filterButton",
  loading = "travelAnalysis.loading",
  totalAnalyzed = "travelAnalysis.totalAnalyzed",
  successfulTrips = "travelAnalysis.successfulTrips",
  successRate = "travelAnalysis.successRate",
  alertsDetected = "travelAnalysis.alertsDetected",
  target = "travelAnalysis.target",
  alertDistributionTitle = "travelAnalysis.alertDistributionTitle",
  noAlertsInPeriod = "travelAnalysis.noAlertsInPeriod",
  successRatioTitle = "travelAnalysis.successRatioTitle",
  noData = "travelAnalysis.noData",
  success = "travelAnalysis.success",
  alerts = "travelAnalysis.alerts",
  efficiency = "travelAnalysis.efficiency",
  geographicMonitoringTitle = "travelAnalysis.geographicMonitoringTitle",
  geographicMonitoringSubtitle = "travelAnalysis.geographicMonitoringSubtitle",
  noGeographicData = "travelAnalysis.noGeographicData",
  activeVehicles = "travelAnalysis.activeVehicles",
  activeAlerts = "travelAnalysis.activeAlerts",
  dashboardSubtitle = "travelAnalysis.dashboardSubtitle",
  percentOfTotal = "travelAnalysis.percentOfTotal",
  alertsListTitle = "travelAnalysis.alertsListTitle",
  columnVehicle = "travelAnalysis.columnVehicle",
  columnAlertType = "travelAnalysis.columnAlertType",
  columnOrigin = "travelAnalysis.columnOrigin",
  columnDestination = "travelAnalysis.columnDestination",
  columnDate = "travelAnalysis.columnDate",
  noAlertsFound = "travelAnalysis.noAlertsFound",
  loadMore = "travelAnalysis.loadMore",
  close = "travelAnalysis.close",
  tripsUnit = "travelAnalysis.tripsUnit",
  columnNumDoc = "travelAnalysis.columnNumDoc",
  columnActions = "travelAnalysis.columnActions",
  viewAlertDetails = "travelAnalysis.viewAlertDetails",
  viewTravel = "travelAnalysis.viewTravel",
  alertDetailsTitle = "travelAnalysis.alertDetailsTitle",
  loadingTravel = "travelAnalysis.loadingTravel",
  // Metadata labels — CAN Data Stall
  metaSource = "travelAnalysis.metaSource",
  metaStallType = "travelAnalysis.metaStallType",
  metaThreshold = "travelAnalysis.metaThreshold",
  metaStalledFields = "travelAnalysis.metaStalledFields",
  metaTotalCanPackets = "travelAnalysis.metaTotalCanPackets",
  // Cross Day Cycle
  metaStartDate = "travelAnalysis.metaStartDate",
  metaFinishDate = "travelAnalysis.metaFinishDate",
  metaStartDay = "travelAnalysis.metaStartDay",
  metaFinishDay = "travelAnalysis.metaFinishDay",
  metaDurationHours = "travelAnalysis.metaDurationHours",
  // False Positive Discharge
  metaTotalDischargeCommands = "travelAnalysis.metaTotalDischargeCommands",
  metaCoveredCommands = "travelAnalysis.metaCoveredCommands",
  metaOrphanCommands = "travelAnalysis.metaOrphanCommands",
  metaOrphanRatio = "travelAnalysis.metaOrphanRatio",
  metaCoveredRanges = "travelAnalysis.metaCoveredRanges",
  // GPRS Connection Instability
  metaTotalPackets = "travelAnalysis.metaTotalPackets",
  metaMemoryCommands = "travelAnalysis.metaMemoryCommands",
  metaEffectiveRealtimeCommands = "travelAnalysis.metaEffectiveRealtimeCommands",
  metaRealtimeCommands = "travelAnalysis.metaRealtimeCommands",
  metaMemoryRatio = "travelAnalysis.metaMemoryRatio",
  metaThresholdPercent = "travelAnalysis.metaThresholdPercent",
  metaEffectiveRealtimeThresholdSeconds = "travelAnalysis.metaEffectiveRealtimeThresholdSeconds",
  metaAvgDelaySeconds = "travelAnalysis.metaAvgDelaySeconds",
  metaMaxDelaySeconds = "travelAnalysis.metaMaxDelaySeconds",
  // GPS Positioning Failure
  metaTotalGpsPackets = "travelAnalysis.metaTotalGpsPackets",
  metaInvalidFixCount = "travelAnalysis.metaInvalidFixCount",
  metaInvalidRatio = "travelAnalysis.metaInvalidRatio",
  metaAvgSatellites = "travelAnalysis.metaAvgSatellites",
  // Hardware Command Deficit
  metaPacketCount = "travelAnalysis.metaPacketCount",
  metaExpectedPackets = "travelAnalysis.metaExpectedPackets",
  metaMinimumRequired = "travelAnalysis.metaMinimumRequired",
  metaDeficitPercent = "travelAnalysis.metaDeficitPercent",
  metaRatePerMinute = "travelAnalysis.metaRatePerMinute",
  metaTravelDurationMinutes = "travelAnalysis.metaTravelDurationMinutes",
  // Logistics Flow Inconsistency
  metaRequiredStates = "travelAnalysis.metaRequiredStates",
  metaActualStates = "travelAnalysis.metaActualStates",
  metaMissingStates = "travelAnalysis.metaMissingStates",
  metaMissingCount = "travelAnalysis.metaMissingCount",
  metaTotalStates = "travelAnalysis.metaTotalStates",
  metaNumDoc = "travelAnalysis.metaNumDoc",
  // Sensor Command Deficit (IDLE)
  metaIgnitionOnCount = "travelAnalysis.metaIgnitionOnCount",
  metaIdleCount = "travelAnalysis.metaIdleCount",
  metaLoadingCount = "travelAnalysis.metaLoadingCount",
  metaUnloadingCount = "travelAnalysis.metaUnloadingCount",
  metaIdleRatio = "travelAnalysis.metaIdleRatio",
  // Grouped success charts
  successByDayTitle = "travelAnalysis.successByDayTitle",
  successByPlantTitle = "travelAnalysis.successByPlantTitle",
  successByRegionalTitle = "travelAnalysis.successByRegionalTitle",
  averageLine = "travelAnalysis.averageLine",
  noGroupedData = "travelAnalysis.noGroupedData",
  coordinateViewTitle = "travelAnalysis.coordinateViewTitle",
  coordinateViewVehicle = "travelAnalysis.coordinateViewVehicle",
  coordinateViewNF = "travelAnalysis.coordinateViewNF",
  coordinateViewGeneral = "travelAnalysis.coordinateViewGeneral",
  coordinateViewContent = "travelAnalysis.coordinateViewContent",
  coordinateViewResult = "travelAnalysis.coordinateViewResult",
  coordinateViewGeneralData = "travelAnalysis.coordinateViewGeneralData",
  coordinateViewCommandContent = "travelAnalysis.coordinateViewCommandContent",
  coordinateViewProcessingResult = "travelAnalysis.coordinateViewProcessingResult",
  coordinateViewNoData = "travelAnalysis.coordinateViewNoData",
  coordinateViewField = "travelAnalysis.coordinateViewField",
  coordinateViewValue = "travelAnalysis.coordinateViewValue",
  // Alert glossary (help drawer)
  glossaryButtonLabel = "travelAnalysis.glossaryButtonLabel",
  glossaryDrawerTitle = "travelAnalysis.glossaryDrawerTitle",
  glossaryIntroTitle = "travelAnalysis.glossaryIntroTitle",
  glossaryIntroText = "travelAnalysis.glossaryIntroText",
  glossaryWhenLabel = "travelAnalysis.glossaryWhenLabel",
  glossaryAppliesLabel = "travelAnalysis.glossaryAppliesLabel",
  glossaryMetadataLabel = "travelAnalysis.glossaryMetadataLabel",
  glossaryAppliesAll = "travelAnalysis.glossaryAppliesAll",
  glossaryAppliesMixerPump = "travelAnalysis.glossaryAppliesMixerPump",
  glossaryAppliesMixer = "travelAnalysis.glossaryAppliesMixer",
  glossaryAppliesMixerDoc = "travelAnalysis.glossaryAppliesMixerDoc",
  // Glossary — GPRS Connection Instability
  glossaryGprsTitle = "travelAnalysis.glossaryGprsTitle",
  glossaryGprsDesc = "travelAnalysis.glossaryGprsDesc",
  glossaryGprsWhen = "travelAnalysis.glossaryGprsWhen",
  glossaryGprsMeta = "travelAnalysis.glossaryGprsMeta",
  // Glossary — GPS Positioning Failure
  glossaryGpsTitle = "travelAnalysis.glossaryGpsTitle",
  glossaryGpsDesc = "travelAnalysis.glossaryGpsDesc",
  glossaryGpsWhen = "travelAnalysis.glossaryGpsWhen",
  glossaryGpsMeta = "travelAnalysis.glossaryGpsMeta",
  // Glossary — Cross Day Cycle
  glossaryCrossDayTitle = "travelAnalysis.glossaryCrossDayTitle",
  glossaryCrossDayDesc = "travelAnalysis.glossaryCrossDayDesc",
  glossaryCrossDayWhen = "travelAnalysis.glossaryCrossDayWhen",
  glossaryCrossDayMeta = "travelAnalysis.glossaryCrossDayMeta",
  // Glossary — Hardware Command Deficit
  glossaryHwDeficitTitle = "travelAnalysis.glossaryHwDeficitTitle",
  glossaryHwDeficitDesc = "travelAnalysis.glossaryHwDeficitDesc",
  glossaryHwDeficitWhen = "travelAnalysis.glossaryHwDeficitWhen",
  glossaryHwDeficitMeta = "travelAnalysis.glossaryHwDeficitMeta",
  // Glossary — Sensor Command Deficit (IDLE)
  glossarySensorIdleTitle = "travelAnalysis.glossarySensorIdleTitle",
  glossarySensorIdleDesc = "travelAnalysis.glossarySensorIdleDesc",
  glossarySensorIdleWhen = "travelAnalysis.glossarySensorIdleWhen",
  glossarySensorIdleMeta = "travelAnalysis.glossarySensorIdleMeta",
  // Glossary — Logistics Flow Inconsistency
  glossaryLogisticsTitle = "travelAnalysis.glossaryLogisticsTitle",
  glossaryLogisticsDesc = "travelAnalysis.glossaryLogisticsDesc",
  glossaryLogisticsWhen = "travelAnalysis.glossaryLogisticsWhen",
  glossaryLogisticsMeta = "travelAnalysis.glossaryLogisticsMeta",
  // Glossary — CAN Data Stall
  glossaryCanStallTitle = "travelAnalysis.glossaryCanStallTitle",
  glossaryCanStallDesc = "travelAnalysis.glossaryCanStallDesc",
  glossaryCanStallWhen = "travelAnalysis.glossaryCanStallWhen",
  glossaryCanStallMeta = "travelAnalysis.glossaryCanStallMeta",
  // Glossary — False Positive Discharge
  glossaryFalseDischargeTitle = "travelAnalysis.glossaryFalseDischargeTitle",
  glossaryFalseDischargeDesc = "travelAnalysis.glossaryFalseDischargeDesc",
  glossaryFalseDischargeWhen = "travelAnalysis.glossaryFalseDischargeWhen",
  glossaryFalseDischargeMeta = "travelAnalysis.glossaryFalseDischargeMeta"
}

export type TranslationTravelAnalysisMessages = {
  [key in TravelAnalysisMessages]: string;
}
